import { History } from '@dialogue/services/dist/active-minutes/model'

/**
 * Check if array of active contains data past 4th week
 * @param data array of active history
 * @returns {boolean}
 */
export function hasMoreActiveHistory(data: History): boolean {
  return (
    data
      ?.slice(4)
      ?.findIndex(({ weekly_progress: { percentage } }) => percentage && percentage > 0) !== -1
  )
}
